module.exports = __webpack_public_path__ + "static/media/1cirqueduceleste1.c083f6c8.jpg";